// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"367":"06bacac8","453":"70d4c0ee","805":"7c6de303"}[chunkId] + ".chunk.js";
};